import React, { Component } from 'react';
import Select from 'react-select';
import withRouter from "../../Utils/withRouter";
import { decodeData } from '../../Constants/constants';

class SalaryDetails extends Component {
  constructor(props) {
    super(props);

    // Initial state to store form data and validation errors
    this.state = {
      minimumWages: '',
      stipend: '',
      monthlyBonus: '',
      washingAllowance: '',
      basic: '',
      HRA: '',
      conveyance: '',
      medicalAllowance: '',
      otherAllowance: '',
      gross: '',
      errors: {},
      decodedData: [],
    };
  }

  componentDidUpdate(prevProps, prevState) {
      if (prevState.permissions !== this.context.permissions) {
        // console.log("Permissions Updated:", this.context.permissions);
          const { permissions } = this.context;
          if (permissions.length > 0) {
            const queryParams = new URLSearchParams(window.location.search);
            const encodedData = queryParams.get("abs");
            const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
            if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
              this.setState({ decodedData });
            }
          } else {
            console.warn("Permissions not yet available. Retrying...");
          }
      }
    }

  // Handler function to update state on input change
  handleInputChange = (e) => {
    const { name, value } = e.target;

    // Clear the specific error related to the changed input
    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };

  // Handler function for Select component change
  handleSelectChange = (name, selectedOption) => {
    // Clear the specific error related to the changed input
    this.setState((prevState) => ({
      [name]: selectedOption.value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };

  // Handler function for form submission
  handleSubmit = (e) => {
    e.preventDefault();

    // Validate the form
    const errors = this.validateForm();

    if (Object.keys(errors).length === 0) {
      // Form is valid, perform further actions with the form data here

      // Example: Log the form data
    } else {
      // Form is not valid, update state with errors
      this.setState({ errors });
    }
  };

  // Custom validation function with regex
  validateForm = () => {
    const errors = {};

    // Validate individual fields
    if (!this.state.bloodGroup) {
      errors.bloodGroup = 'Blood Group is required';
    }

    if (!this.state.employeeCategory) {
      errors.employeeCategory = 'Employee Category is required';
    }

    if (!this.state.employeeType) {
      errors.employeeType = 'Employee Type is required';
    }

    if (!this.state.permanentAddress) {
      errors.permanentAddress = 'Permanent Address is required';
    }

    // Regex for valid 6-digit pin code
    const pinCodeRegex = /^[0-9]{6}$/;

    if (!this.state.pinCode) {
      errors.pinCode = 'Pin Code is required';
    } else if (!pinCodeRegex.test(this.state.pinCode)) {
      errors.pinCode = 'Invalid Pin Code. Must be a 6-digit number.';
    }

    // Add more validation rules as needed

    return errors;
  };

  render() {
    const { errors } = this.state;

    return (
      <div>
      <h5>
      Salary Details{" "}
        <span
          style={{
            color: "blue",
            marginLeft: "5px",
            borderRadius: "50%",
            background: "#f0f8ff",
            padding: "2px 6px",
            display: "inline-block",
            textAlign: "center",
            width: "20px",
            height: "20px",
            lineHeight: "20px",
          }}
        >
          *
        </span>
      </h5>
      <p className="text-muted">
        Fill all information below
      </p>
   
      
      <div className="container mt-2">
        <form onSubmit={this.handleSubmit}>

          

          {/* First Column */}
          <div className="row">
          <div className="col-md-6 mb-3">
              <label htmlFor="minimumWages" className="form-label">Minimum Wages:</label>
              <input
                type="number"
                id="minimumWages"
                name="minimumWages"
                value={this.state.minimumWages}
                onChange={this.handleInputChange}
                className={`form-control ${errors.minimumWages ? 'is-invalid' : ''}`}
                placeholder="Enter Minimum Wages"
                required
              />
              {errors.minimumWages && <div className="invalid-feedback">{errors.minimumWages}</div>}
            </div>
          <div className="col-md-6 mb-3">
              <label htmlFor="basic" className="form-label">Basic:</label>
              <input
                type="number"
                id="basic"
                name="basic"
                value={this.state.basic}
                onChange={this.handleInputChange}
                className={`form-control ${errors.basic ? 'is-invalid' : ''}`}
                placeholder="Enter Basic"
                required
              />
              {errors.basic && <div className="invalid-feedback">{errors.basic}</div>}
            </div>
          <div className="col-md-6 mb-3">
              <label htmlFor="HRA" className="form-label">HRA:</label>
              <input
                type="number"
                id="HRA"
                name="HRA"
                value={this.state.HRA}
                onChange={this.handleInputChange}
                className={`form-control ${errors.HRA ? 'is-invalid' : ''}`}
                placeholder="Enter HRA"
                required
              />
              {errors.HRA && <div className="invalid-feedback">{errors.HRA}</div>}
            </div>
          <div className="col-md-6 mb-3">
              <label htmlFor="conveyance" className="form-label">Conveyance:</label>
              <input
                type="number"
                id="conveyance"
                name="conveyance"
                value={this.state.conveyance}
                onChange={this.handleInputChange}
                className={`form-control ${errors.conveyance ? 'is-invalid' : ''}`}
                placeholder="Enter Conveyance"
                required
              />
              {errors.conveyance && <div className="invalid-feedback">{errors.conveyance}</div>}
            </div>
          <div className="col-md-6 mb-3">
              <label htmlFor="medicalAllowance" className="form-label">Medical Allowance:</label>
              <input
                type="number"
                id="medicalAllowance"
                name="medicalAllowance"
                value={this.state.medicalAllowance}
                onChange={this.handleInputChange}
                className={`form-control ${errors.medicalAllowance ? 'is-invalid' : ''}`}
                placeholder="Enter Medical Allowance"
                required
              />
              {errors.medicalAllowance && <div className="invalid-feedback">{errors.medicalAllowance}</div>}
            </div>
          <div className="col-md-6 mb-3">
              <label htmlFor="otherAllowance" className="form-label">Other Allowance:</label>
              <input
                type="number"
                id="otherAllowance"
                name="otherAllowance"
                value={this.state.otherAllowance}
                onChange={this.handleInputChange}
                className={`form-control ${errors.otherAllowance ? 'is-invalid' : ''}`}
                placeholder="Enter Other Allowance"
                required
              />
              {errors.otherAllowance && <div className="invalid-feedback">{errors.otherAllowance}</div>}
            </div>

            <div className="col-md-6 mb-3">
              <label htmlFor="stipend" className="form-label">Stipend:</label>
              <input
                type="number"
                id="stipend"
                name="stipend"
                value={this.state.stipend}
                onChange={this.handleInputChange}
                className={`form-control ${errors.stipend ? 'is-invalid' : ''}`}
                placeholder="Enter Stipend"
                required
              />
              {errors.stipend && <div className="invalid-feedback">{errors.stipend}</div>}
            </div>
            <div className="col-md-6 mb-3">
              <label htmlFor="monthlyBonus" className="form-label">Monthly Bonus:</label>
              <input
                type="number"
                id="monthlyBonus"
                name="monthlyBonus"
                value={this.state.monthlyBonus}
                onChange={this.handleInputChange}
                className={`form-control ${errors.monthlyBonus ? 'is-invalid' : ''}`}
                placeholder="Enter Monthly Bonus"
                required
              />
              {errors.monthlyBonus && <div className="invalid-feedback">{errors.monthlyBonus}</div>}
            </div>
          </div>

          {/* Second Column */}
          <div className="row">
            

            <div className="col-md-6 mb-3">
              <label htmlFor="washingAllovance" className="form-label">Washing Allovance:</label>
              <input
                type='number'
                id="washingAllovance"
                name="washingAllovance"
                value={this.state.washingAllovance}
                onChange={this.handleInputChange}
                className={`form-control ${errors.washingAllovance ? 'is-invalid' : ''}`}
                placeholder="Enter Washing Allovance"
                required
              ></input>
              {errors.washingAllovance && <div className="invalid-feedback">{errors.washingAllovance}</div>}
            </div>
            <div className="col-md-6 mb-3">
              <label htmlFor="gross" className="form-label">Gross:</label>
              <input
                type='number'
                id="gross"
                name="gross"
                value={this.state.gross}
                onChange={this.handleInputChange}
                className={`form-control ${errors.gross ? 'is-invalid' : ''}`}
                placeholder="Enter Gross"
                required
              ></input>
              {errors.gross && <div className="invalid-feedback">{errors.gross}</div>}
            </div>
          </div>
          </form>
        
     
      </div>
      <div className="d-flex justify-content-end"   >
              <button type="submit" className="btn btn-success btn-label waves-effect right waves-light">
                <i className="bx bx-save label-icon align-middle fs-16 ms-2" /> Save
              </button>
            </div>
      </div>
    );
  }
}

export default withRouter(SalaryDetails);
